import React from "react";
import { Link } from "react-router-dom";
import AccessoiresData from "../../../../../api/OtherAccessoiresData";

const BlogSidebar = ({ selectedAccesoire }) => {
  return (
    <div className={`col col-lg-4 col-12 order-lg-1`}>
      <div className="blog-sidebar">
        <div className="widget category-widget">
          <h3>Accesoires</h3>
          <ul>
            {AccessoiresData.map((acc) =>
              acc.id === selectedAccesoire.id ? (
                <li
                  className={`accesoires-links accesoires-links-active`}
                  key={acc.id}
                >
                  <Link to={`/others/autre_accesoires/${acc.id}`}>{acc.title}</Link>
                </li>
              ) : (
                <li className={`accesoires-links`} key={acc.id}>
                  <Link to={`/others/autre_accesoires/${acc.id}`}>{acc.title}</Link>
                </li>
              )
            )}
          </ul>
        </div>


      </div>
    </div>
  );
};

export default BlogSidebar;
